/**
 * General tools used all over Sculpteo
 * @namespace
 */
var Utils = {
  /**
   * Fetches the desired cookie by name
   * @memberof Utils
   * @param {string} c_name - The name of the cookie to fetch
   * @returns {string|null} - The desired cookie
   */
  getCookie: function (c_name) {
    if (document.cookie.length > 0) {
      var c_start = document.cookie.indexOf(c_name + "=");

      if (c_start != -1) {
        c_start = c_start + c_name.length + 1;
        var c_end = document.cookie.indexOf(";", c_start);

        if (c_end == -1) {
          c_end = document.cookie.length;
        }

        return unescape(document.cookie.substring(c_start, c_end));
      }
    }

    return null;
  },

  /**
   * Sets a new cookie
   * @memberof Utils
   * @param {string} c_name - The name of the cookie to set
   * @param {string} value - Value to set
   * @param {number} [expiredays=""] - Number of days before expiry
   * @param {string} [path=""] - The cookie's desired path, if any
   * @param {string} [domain=""] - The domain for the cookie
   */
  setCookie: function (c_name, value, expiredays, path, domain) {
    document.cookie =
      c_name +
      "=" +
      escape(value) +
      (expiredays
        ? ";expires=" +
          new Date(
            new Date().getTime() + parseInt(expiredays * 1000 * 60 * 60 * 24)
          ).toGMTString()
        : "") +
      (path ? ";path=" + path : "") +
      (domain ? ";domain=" + domain : "") +
      ";secure";
  },

  /**
   * Deletes an existing cookie (sets expiredays to -1)
   * @memberof Utils
   * @param {string} c_name - The name of the cookie to delete
   * @param {string} [path=""] - The cookie's path
   * @param {string} [domain=""] - The domain of the cookie to delete
   */
  delCookie: function (c_name, path, domain) {
    Utils.setCookie(c_name, "", -1, path, domain);
  },

  allJobsDone: function (jobs) {
    for (var k in jobs) {
      if (jobs[k]) return false;
    }
    return true;
  },

  jobIsDone: function (jobs, job) {
    jobs[job.uuid] = false;
  },

  _waitJobs: function (jobs, dfd) {
    jobDict = {};
    jobs.forEach(function (job) {
      //job is running
      jobDict[job.uuid] = true;
    });
    var jobsRunning = sculpteoJob(jobs);
    jobsRunning.done(function (job, msg) {
      Utils.jobIsDone(jobDict, job);
      if (Utils.allJobsDone(jobDict)) {
        dfd.resolve();
      }
    });
  },

  waitJobs: function (data) {
    var dfd = $.Deferred();
    if (data.jobs && data.jobs.length > 0) {
      Utils._waitJobs(data.jobs, dfd);
    } else {
      dfd.resolve();
    }
    return dfd.promise();
  },

  checkCartAndReorder: function (order_id) {
    var deferred = $.Deferred();
    checkExistingCart()
      .done(function () {
        // if the user agrees to add the items into his existing cart then add the items
        reorderOrderItems(order_id)
          .done(function (data) {
            Utils.waitJobs(data).done(function () {
              // redirection to cart when everything went smoothly
              window.location = data.url;

              deferred.resolve();
            });
          })
          .fail(function (error) {
            // handle the errors that can come up from reorder
            if (error == "materials_not_available") {
              jAlert(
                gettext(
                  "Some items can not be ordered because of the materials are not available"
                ),
                "Failure"
              );
            } else if (error == "no_order_id") {
              jAlert(gettext("No valid order to reorder"), "Failure");
            } else {
              jAlert(gettext("An error occured"), "Failure");
            }

            deferred.reject();
          });
      })
      .fail(function () {
        // when the request user declined the offer we don't do shit
        deferred.reject();
      });
    return deferred;
  },

  /**
   * Slugifies text
   */
  slugify: function (text) {
    return text
      .toString()
      .toLowerCase()
      .replace(/\s+/g, "-") // Replace spaces with -
      .replace(/[^\w\-]+/g, "") // Remove all non-word chars
      .replace(/\-\-+/g, "-") // Replace multiple - with single -
      .replace(/^-+/, "") // Trim - from start of text
      .replace(/-+$/, ""); // Trim - from end of text
  },
  /**
   * Runs ABTest, sending an event to Analytics for each use, and optionally a 'measure' event
   * @memberof Utils
   * @param {string} name The name of the test to run/check
   * @param {boolean} [ping] Whether or not to send a measure event to Analytics
   */
  abTest: function (name, ping) {
    var currentTest = Utils.getCookie(name);

    if (currentTest === null) {
      // Randomize (gives boolean)
      currentTest = Math.random() > 0.5;

      // Set tests to last 2 weeks
      Utils.setCookie(name, currentTest ? "1" : "0", 14, "/");
    } else {
      // Convert to boolean
      currentTest = currentTest == "1";
    }

    return currentTest; // We can also test using the function
  },

  // Stolen from underscore.js
  // Probably
  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  debounce: function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  },

  absolutePosition: function (el, p_el) {
    // Absolute position of el, relative
    // to top-left of p_el (if
    // undefined, the top-left window)
    if (p_el) {
      p_el = $(p_el).get(0); // P_el must be position:relative to be an
      // offsetParent
    }

    el = $(el).get(0);
    var curleft = el.offsetLeft || 0;
    var curtop = el.offsetTop || 0;

    while ((el = el.offsetParent)) {
      curleft += el.offsetLeft;
      curtop += el.offsetTop;

      if (p_el) {
        if (el == p_el) {
          break;
        }
      }
    }

    return {
      x: curleft,
      y: curtop,
    };
  },

  localMouse: function (evt) {
    var c = Utils.absolutePosition(evt.target);

    return {
      x: evt.pageX - c.x,
      y: evt.pageY - c.y,
    };
  },

  show_lateral_alert: function (o) {
    var options = o;
    var defaults = {
      msg_class: "",
      target_el_selector: "",
      desc: "",
      hideAfter: false,
      offsetLeft: 0,
      offsetTop: 0,
    };

    var options = $.extend(defaults, o);

    $(".lateral_alert_pad." + o.msg_class).hide();
    var pos = $(o.target_el_selector).position();

    $(".lateral_alert")
      .css({
        opacity: 0,
        top: pos.top + o.offsetTop,
        left: pos.left - 248,
      })
      .animate({
        opacity: 1,
        top: pos.top + o.offsetTop - 15,
        left: pos.left - 248,
      })
      .show()
      .click(function () {
        $(this).hide();
      });

    $(".lateral_alert_pad." + o.msg_class + ".ErrorDescription").html(
      o.desc ? o.desc : ""
    );
    $(".lateral_alert_pad." + o.msg_class)
      .closest(".lateral_alert_pad." + o.msg_class)
      .show();

    if (o.hideAfter) {
      var timeout;

      if (typeof o.hideAfter != "boolean") {
        timeout = o.hideAfter;
      } else {
        timeout = 2000;
      }

      setTimeout(function () {
        $(".lateral_alert").fadeOut("slow");
      }, timeout);
    }
  },

  hide_lateral_alert: function () {
    $(".lateral_alert").height(0);
    $(".lateral_alert").hide();
    $(".lateral_alert_right").hide();
  },

  show_lateral_alert_right: function (o) {
    var options = o;
    var defaults = {
      msg_class: "",
      target_el_selector: "",
      desc: "",
      hideAfter: false,
      offsetLeft: 0,
      offsetTop: 0,
    };
    var options = $.extend(defaults, o);

    $(".lateral_alert_pad." + o.msg_class).hide();
    var pos = $(o.target_el_selector).position();

    $(".lateral_alert_pad." + o.msg_class)
      .closest(".lateral_alert_right")
      .css({
        opacity: 0,
        top: pos.top + o.offsetTop + 25,
        left: pos.left + o.offsetLeft,
      })
      .animate({
        opacity: 1,
        top: pos.top + o.offsetTop + 10,
        left: pos.left + o.offsetLeft,
      })
      .show()
      .click(function () {
        $(this).hide();
      });

    $(".lateral_alert_pad." + o.msg_class + ".ErrorDescription").html(
      o.desc ? o.desc : ""
    );
    $(".lateral_alert_pad." + o.msg_class).show();

    if (o.hideAfter) {
      var timeout;

      if (typeof o.hideAfter != "boolean") {
        timeout = o.hideAfter;
      } else {
        timeout = 2000;
      }

      setTimeout(function () {
        $(".lateral_alert_right").animate(
          {
            height: "0px",
          },
          200
        );

        // $(".lateral_alert_right").fadeOut('slow');
      }, timeout);
    }
  },

  is_array: function (input) {
    return typeof input == "object" && input instanceof Array;
  },

  // Needed to add a class here...
  popupMessage: function (s, new_class) {
    $("#other_message_content").html(s);
    $("#other_message").addClass(new_class);
    $("#other_message").slideDown();
    setTimeout(function () {
      $("#other_message").fadeOut("slow", function () {
        $("#other_message").removeClass(new_class);
      });
    }, 4000);
  },

  loop: function (_this, start, len, step, body, done, abort) {
    var i = start;
    var _loop = function () {
      if (abort && abort()) {
        return;
      }

      var count = 0;

      for (; i < len && count < step; i++, count++) {
        body.call(_this, i);
      }

      if (i == len) {
        done.call(_this);
      } else {
        setTimeout(_loop, 0);
      }
    };

    setTimeout(_loop, 0);
  },

  uniqueString: function () {
    return (
      new Date().getTime().toString(16) +
      Math.floor(Math.random() * (1 << 30)).toString(16)
    );
  },

  fixedFloat: function (f, p) {
    /* The float f and the precision p */
    var precision = p ? p : 3;
    var nicePrecision = Math.max(
      0,
      precision + 1 - (Math.round(f) + "").length
    );

    // Return a string like this : 1.000 / 10.00 / 100.0 / 1000 if p=3
    return f.toFixed(nicePrecision);
  },

  nextUrlClick: function (evt) {
    location.href =
      evt.href +
      "?next=" +
      encodeURIComponent(location.pathname + location.search + location.hash);

    return false;
  },

  setNavigationPoint: function (title) {
    Utils.setCookie("navigation", document.location.href, 1, "/");
    Utils.setCookie("navigation-title", title, 1, "/");
  },

  getNavigationPoint: function () {
    var a = {
      url: Utils.getCookie("navigation"),
      title: Utils.getCookie("navigation-title"),
    };

    return a;
  },

  /**
   * Passed the 'delete' url of the design, this will ask for confirmation from the user and then
   * make the request for deletion to the server. Optional callbacks are available for the user's
   * response and the server's response
   *
   * @param {string} url - The 'delete design' url of the design, including an optional
   * 		<tt>?next=</tt> parameter for redirection after deletion
   * @param {Object} [on_answer] - Callback funciton for when the user responds to the
   * 		confirmation dialog
   * @param {Object} [callback] - Callback function upon completion
   */
  delete_design: function (url, on_answer, callback) {
    jConfirm(
      gettext("Are you sure you want to delete this design ?"),
      "Confirmation",
      function (r) {
        if (on_answer) {
          on_answer(r);
        }

        if (r) {
          $.post(url, {}, function (data, textStatus) {
            if (callback) {
              callback(true, data);
            }

            if (data.next) {
              location.href = data.next;
            }
          }).fail(function () {
            if (callback) {
              callback(false);
            }
          });
        }
      },
      gettext("Yes"),
      gettext("No")
    );

    return false;
  },

  /**
   * Given an existing design's 'save as new' url, will save it as a new design in the user
   * gallery (splits this design from the version set and makes it a first class design)
   *
   * @param {Object} url - The 'save as new' url for the design
   */
  save_as_new_design: function (url) {
    $.post(url, {}, function (data, textStatus) {
      location.href = data.next;
    });
  },

  /**
   * Make design public
   *
   * @param {string} url
   * @param {object} event
   */
  make_public: function (url, event) {
    event.stopPropagation();

    $.post(url, { share: "f" }, function (data, textStatus) {
      $(event.target).hide();
      $(event.target).next().show();
      $(event.target).parent().hide();
    });
  },

  /**
   * Make design private
   *
   * @param {string} url
   * @param {object} event
   */
  make_private: function (url, event) {
    event.stopPropagation();

    $.post(url, { share: "p" }, function (data, textStatus) {
      $(event.target).hide();
      $(event.target).prev().show();
      $(event.target).parent().hide();
    });
  },

  /**
   * Checks if the container passed has vertical overflow or not (with an optional fudgefactor)
   *
   * @param {Object} $el - A jQuery element
   * @param {number} [fuzz = 4] - a fudge factor to allow for borders and margin weirdness
   */
  hasHeightOverflow: function ($el, fuzz) {
    var factor = fuzz || 4;

    if ($el.length) {
      var container = $el[0];

      return container.scrollHeight - container.clientHeight >= factor;
    }

    return false;
  },

  /**
   * Provided a container id, will select all text in that container. Useful for pre-highlighting
   * the  embed code for the user (but they still have to do the <tt>ctrl + c</tt> )
   *
   * @param {string} containerid - The id of the container to select text in
   */
  selectText: function (containerid) {
    if (document.selection) {
      var range = document.body.createTextRange();

      range.moveToElementText(document.getElementById(containerid));
      range.select();
    } else if (window.getSelection) {
      var range = document.createRange();

      range.selectNode(document.getElementById(containerid));
      window.getSelection().addRange(range);
    }
  },

  /**
   * Given a design, and a number, will trim the decimal points of that number appropriately for
   * the current unit of measurement of the design.
   *
   * @param {object} design - The design for which teh scale applies
   * @param {string|number} num - The scale value that needs to be trimmed (can be passed as a string)
   * @return {number} - The correctly trimmed number
   */
  decimalPrecision: function (design, num) {
    if (typeof num === "string") {
      num = parseFloat(num);
    }

    switch (design.size.unit) {
      case "cm":
      case "in":
      case "yd":
      case "m":
      case "ft":
        num = num.toFixed(2);
        break;
      default:
        num = num.toFixed(1);
    }

    return num;
  },

  /**
   * Adds a progress bar to the viewer which can be determinate (0-100) or indeterminate (a spinner)
   * If percent is given (int, 1-100), will spawn a determinate progress bar at the given percentage
   * delay is the time to increment in ms.
   * If no percent is given, an indeterminate progress bar (K2000) will be spawned
   * To stop either bar, simply give a percentage of 0
   * @author Alex Gryson alex.gryson@sculpteo.com
   *
   * @param {number} [percent] - The percentage of progress to be shown, if any
   * @param {number} [delay=400] - The time, in ms, for the bar to animate to the provided percentage
   */
  viewerProgressBar: function (percent, delay) {
    delay = delay || 400;
    var containerWidth = parseInt($(".viewer-toolbar-loader").width(), 10);
    var _this = this;

    // Reset the bar
    if (percent === 0) {
      $(".viewer-toolbar-loader span").stop(true, false);
      _this.stopTimer = true;
      $(".viewer-toolbar-loader span").animate(
        { height: "0" },
        200,
        "linear",
        function () {
          _this.stopTimer = false;
          $(".viewer-toolbar-loader span").css("width", 0);
          $(".viewer-toolbar-loader span").css("margin-left", "");
          $(".viewer-toolbar-loader span").css("height", "100%");
        }
      );

      // Determinate progress bar (between 0-100)
    } else if (percent) {
      var factor = containerWidth / 100;

      _this.stopTimer = true;
      $(".viewer-toolbar-loader span").stop(true, false);
      $(".viewer-toolbar-loader span").css("margin-left", "");
      $(".viewer-toolbar-loader span").animate(
        {
          width: percent * factor + "px",
        },
        delay,
        "easeInOutSine",
        function () {
          _this.stopTimer = false;
        }
      );

      // Indeterminate spinner (just bounces until action complete)
    } else {
      $(".viewer-toolbar-loader span").stop(false, true);

      if (_this.stopTimer) {
        _this.animRight = false;
        _this.stopTimer = false;
      } else {
        $(".viewer-toolbar-loader span").css("width", 100);
        var anim = function () {
          if (_this.animRight) {
            $(".viewer-toolbar-loader span").animate(
              {
                marginLeft: (containerWidth / 100) * 30 - 50 + "px",
              },
              1000,
              "easeInOutSine",
              function () {
                anim();
              }
            );

            _this.animRight = false;
          } else {
            $(".viewer-toolbar-loader span").animate(
              {
                marginLeft: (containerWidth / 100) * 70 - 50 + "px",
              },
              1000,
              "easeInOutSine",
              function () {
                anim();
              }
            );

            _this.animRight = true;
          }
        };

        $(".viewer-toolbar-loader span").css(
          "marginLeft",
          (containerWidth / 100) * 30
        );
        anim();
      }
    }
  },

  /**
   * For multiple namespaces trying to manage enabling/disabling of an interface element,
   * <tt>namespacedDisable()</tt> acts as a third party to arbitrate between them.
   * e.g. Hollowing disables 'Add to Cart' while editing. Before saving the hollowing, the user
   * changes material, to an inappropriate material/scale. Material now disables 'Add to Cart'.
   * When Hollowing is finished, it releases its block on adding to cart, but Material's is still
   * in place, so the button remains disabled.
   * @param {number[]} state - Stores the collective state for all namespaces.
   * 		See {@link PriceWidget.review_btn_disable}
   * @param {string} namespace - The namespace for which we're changing state
   * @param {boolean} enable - Whether this namespace is releasing its 'lock' or not
   * @param {object} onEnable - Callback function on the interface element being 'enablable'
   * @param {object} onDisable - Callback function on the interface element being 'disableable'
   */
  namespacedDisable: function (state, namespace, enable, onEnable, onDisable) {
    if (enable) {
      state[namespace] = 0;
      var do_enable = true;

      for (var i in state) {
        if (state.hasOwnProperty(i) && state[i]) {
          do_enable = false;
          break;
        }
      }

      if (do_enable && onEnable) {
        onEnable();
      }
    } else {
      state[namespace] = 1;

      if (onDisable) {
        onDisable();
      }
    }
  },

  updateAllNewEvent: function (c_name) {
    var data = {
      events_all: true,
    };

    //call the method with the urlEventCenterUpdate ( set in the html )
    $.ajax({
      url: URLS.eventCenterUpdate,
      type: "GET",
      data: data,
      success: function (response) {
        if (response.valid == "true") {
          // CASE - dashboard and event_center table row event
          // ------------------------------------------
          // get all the event row that are new ( only visible on dashboard home and event_center)
          var $rowEventIsNew = $(".js-event-row.js-event-row-is-new");
          // only if there is some event row
          if ($rowEventIsNew.length != 0) {
            // for each event row listed before
            $rowEventIsNew.each(function (index) {
              // the event container
              var $eventContainer = $(this);

              // calculate a delay based on the total and the index of the event * 500ms
              var delay = index * 300;

              // fade out the tag based on the delay + remove the class when it is done
              // the class removed will display none the tag (avoid issue)
              $(".js-event-new-tag", $eventContainer)
                .delay(delay)
                .fadeOut(200, function () {
                  $eventContainer.removeClass("event-row-is-new");
                });
            });
          }
          // ------------------------------------------

          // CASE - table header in event_center
          // ------------------------------------------
          // only if there is a center event header, for the moment only on event_center
          // note: on the dashboard the header is not displayed
          if ($(".js-flexbox-table-header").length != 0) {
            // set the number of new event in all categories to 0 in this header
            $(".js-event-tags-tag", ".js-flexbox-table-header").html(0);
          }
          // ------------------------------------------

          // CASE - dashboard menu and site menu
          // ------------------------------------------
          // this class is use in the menu and dashboard menu
          // this is the badge with the number of new event
          // we need to hide it
          $(".js-dashboard-menu-events-count").hide();
          // get the icon class and change his icon
          $(".js-dashboard-menu-event-center-icon")
            .removeClass("icon-notifications_active")
            .addClass("icon-notifications_none");

          // CASE - site menu specific
          // ------------------------------------------
          // in the menu, display the total of new message. we need to set it to 0
          $(".js-menu-event-total-count").html(0);

          // and hide the critical
          $(".js-menu-event-tag-critical").hide();

          // variable use for the polling and set in the menu by django
          // we need to reset it
          window.currentTotalNewEvent = 0;
        } else {
          console.log("an error occured");
        }
      }.bind(this),
    });
  },

  pollingNewEvents: function () {
    var data = {};
    $.ajax({
      url: URLS.eventCenterPollingNewEvent,
      type: "GET",
      data: data,
      success: function (response) {
        if (response.valid == "true") {
          // list of ALL new events, event.new = true
          // So it is an array of all the event despite the fact that the user already saw that there is new event
          var listAllNewEvent = response.list_new_events;
          // total of new events
          var eventNewCount = listAllNewEvent.length;

          // test if the new total is superior to the old one
          if (eventNewCount > window.currentTotalNewEvent) {
            // total of critical
            var eventCriticalCount = response.list_new_events.filter(function (
              value
            ) {
              return value.is_critical;
            }).length;

            // calculate the diff between the new total of new event and the old count
            var eventDiffCount = eventNewCount - window.currentTotalNewEvent;

            // list of event that are really new (for the user)
            // event that are created while the user was on the page
            var listEventsNew = response.list_new_events.slice(
              eventNewCount - eventDiffCount,
              eventNewCount
            );

            // array of only critical new event
            var listEventsNewAndCritical = listEventsNew.filter(function (
              value
            ) {
              return value.is_critical;
            });

            // CASE - notification
            // ----------------------------
            var sendNotification = false;
            // Let's check if the browser supports notifications
            if (!("Notification" in window)) {
              console.log("Notification is not supported on this browser");
            }
            // Let's check whether notification permissions have already been granted
            else if (Notification.permission === "granted") {
              // If it's okay
              sendNotification = true;
            }
            // Otherwise, we need to ask the user for permission
            else if (Notification.permission !== "denied") {
              Notification.requestPermission(function (permission) {
                // If the user accepts, let's create a notification
                if (permission === "granted") {
                  sendNotification == true;
                }
              });
            }

            if (sendNotification) {
              // create the body
              var notificationBody = gettext(
                "There is XXXXX new event in your event center."
              ).replace("XXXXX", eventDiffCount);

              if (listEventsNewAndCritical.length != 0) {
                notificationBody +=
                  " " +
                  gettext("XXXXX are critical.").replace(
                    "XXXXX",
                    listEventsNewAndCritical.length
                  );
              }

              var notificationTitle = gettext("New event from Sculpteo");

              var notificationIcon = $(".js-menu-event-center-icon").data(
                "url-notification-icon"
              );

              // send the notification
              var notification = Utils.spawnNotification(
                notificationBody,
                notificationIcon,
                notificationTitle
              );
            }
            // -------------------------------------

            // CASE - dashboard menu and site menu
            // ------------------------------------------
            var $dashboardMenuEventsCount = $(
              ".js-dashboard-menu-events-count"
            );
            // this class is use in the menu and dashboard menu
            // this is the badge with the number of new event
            // we need to show it
            $dashboardMenuEventsCount.show();
            // set the new total
            $dashboardMenuEventsCount.html(eventNewCount);
            // get the icon class and change his icon if necessary
            $(".js-dashboard-menu-event-center-icon")
              .removeClass("icon-notifications_none")
              .addClass("icon-notifications_active");

            // CASE - site menu specific
            // ------------------------------------------
            // in the menu, display the total of new message. we set it with the total of event new
            $(".js-menu-event-total-count").html(eventNewCount);

            // and show the critical
            $(".js-menu-event-tag-critical").show();
            // + set the total of new critical
            $(".js-menu-event-critical-total-count").html(eventCriticalCount);

            // enable the button mark as read
            $(".js-menu-event-mark-as-read").removeClass("disabled");

            // set the old total with the new value of new events
            window.currentTotalNewEvent = eventNewCount;
          }
        } else {
          console.log("no new event");
        }
      }.bind(this),
    });
  },

  // generate a notification in the browser
  spawnNotification: function (body, icon, title) {
    var options = {
      body: body,
      icon: icon,
    };

    var n = new Notification(title, options);
  },

  /**
   * Escape strings from HTML interpolation
   * Copied from underscore.js
   * @param {string} str String to escape
   * @returns {string} Escaped string
   */
  escapeHTML: function (string) {
    var escapeMap = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#x27;",
      "`": "&#x60;",
    };

    // Functions for escaping strings to/from HTML interpolation.
    var escaper = function (match) {
      return escapeMap[match];
    };

    // Regexes for identifying a key that needs to be escaped
    var source = "(?:" + Object.keys(escapeMap).join("|") + ")";
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, "g");
    string = string == null ? "" : "" + string;
    return testRegexp.test(string)
      ? string.replace(replaceRegexp, escaper)
      : string;
  },
};

// refactoring the code for reorder_order_items
function checkExistingCart() {
  var deferred = $.Deferred();
  $.ajax({
    url: URLS.check_existing_cart,
    type: "POST",
    data: {},
    success: function (response) {
      if (response.error.id == 1) {
        jConfirm(
          gettext(
            "There are already some items in your cart. Are you sure you are willing to add this order to your cart?"
          ),
          "Confirmation",
          function (r) {
            if (r) {
              deferred.resolve();
            } else {
              deferred.reject();
            }
          }
        );
      } else {
        deferred.resolve();
      }
    },
  });
  return deferred;
}

function reorderOrderItems(order_id) {
  var deferred = $.Deferred();
  var data = {
    order_id: order_id,
  };
  $.ajax({
    url: URLS.reorder_items,
    type: "POST",
    data: data,
    success: function (response) {
      if (response.error != "") {
        deferred.reject(response.error);
      } else {
        deferred.resolve(response);
      }
    },
  });
  return deferred;
}

/**
 * ParseUri 1.2.2
 * @author Steven Levithan <stevenlevithan.com>
 * @copyright Steven Levithan <stevenlevithan.com>
 * @license MIT License
 */
function parseUri(str) {
  var o = parseUri.options,
    m = o.parser[o.strictMode ? "strict" : "loose"].exec(str),
    uri = {},
    i = 14;

  while (i--) {
    uri[o.key[i]] = m[i] || "";
  }

  uri[o.q.name] = {};
  uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
    if ($1) {
      uri[o.q.name][$1] = $2;
    }
  });

  return uri;
}

parseUri.options = {
  strictMode: false,
  key: [
    "source",
    "protocol",
    "authority",
    "userInfo",
    "user",
    "password",
    "host",
    "port",
    "relative",
    "path",
    "directory",
    "file",
    "query",
    "anchor",
  ],
  q: {
    name: "queryKey",
    parser: /(?:^|&)([^&=]*)=?([^&]*)/g,
  },
  parser: {
    strict:
      /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
    loose:
      /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/,
  },
};

function getBaseURL() {
  return document.location.protocol + "//" + DOMAIN;
}

String.prototype.startsWith = function (t) {
  return typeof t != "undefined" && t == this.substring(0, t.length);
};

String.prototype.endsWith = function (t, i) {
  return typeof t != "undefined" && t == this.substring(this.length - t.length);
};

String.prototype.truncate = function (l) {
  if (this.length > l) {
    return this.substring(0, l - 3) + "...";
  }

  return this;
};

String.format = function () {
  var s = arguments[0];

  for (var i = 0; i < arguments.length - 1; i++) {
    var reg = new RegExp("\\{" + i + "\\}", "gm");

    s = s.replace(reg, arguments[i + 1]);
  }

  return s;
};

Object.size = function (obj) {
  var size = 0,
    key;

  for (key in obj) {
    if (obj.hasOwnProperty(key)) {
      size++;
    }
  }

  return size;
};

if (!Object.assign) {
  Object.assign = function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  };
}

function concatObject(obj) {
  var str = "";

  for (prop in obj) {
    str += prop + ": " + obj[prop] + "\n";
  }

  return str;
}

function printStackTrace() {
  var callstack = [];
  var isCallstackPopulated = false;

  try {
    i.dont.exist += 0; // Doesn't exist- that's the point
  } catch (e) {
    if (e.stack) {
      // Firefox
      var lines = e.stack.split("\n");

      for (var i = 0, len = lines.length; i < len; i++) {
        if (lines[i].match(/^\s*[A-Za-z0-9\-_\$]+\(/)) {
          callstack.push(lines[i]);
        }
      }

      // Remove call to printStackTrace()
      callstack.shift();
      isCallstackPopulated = true;
    } else if (window.opera && e.message) {
      // Opera
      var lines = e.message.split("\n");

      for (var i = 0, len = lines.length; i < len; i++) {
        if (lines[i].match(/^\s*[A-Za-z0-9\-_\$]+\(/)) {
          var entry = lines[i];

          // Append next line also since it has the file info
          if (lines[i + 1]) {
            entry += " at " + lines[i + 1];
            i++;
          }

          callstack.push(entry);
        }
      }

      // Remove call to printStackTrace()
      callstack.shift();
      isCallstackPopulated = true;
    }
  }

  if (!isCallstackPopulated) {
    // IE and Safari
    var currentFunction = arguments.callee.caller;

    while (currentFunction) {
      var fn = currentFunction.toString();
      var fname =
        fn.substring(fn.indexOf("function") + 8, fn.indexOf("")) || "anonymous";

      callstack.push(fname);
      currentFunction = currentFunction.caller;
    }
  }

  log(callstack);
}

function extractIdFromClass(el, class_prefix) {
  var fieldClasses = $(el).attr("class");

  if (fieldClasses) {
    fieldClasses = fieldClasses.split(" ");

    for (_klass in fieldClasses) {
      klass = fieldClasses[_klass];

      if (klass.startsWith(class_prefix)) {
        return klass.substring(class_prefix.length, klass.length);
      }
    }
  }
}

function from_JSON(s) {
  try {
    if (!s || !$.trim(s)) {
      return {};
    }

    return (window.JSON && window.JSON.parse(s)) || eval("(" + s + ")");
  } catch (err) {
    return {};
  }
}

(function ($) {
  var internal = {
    sizeScrollbar: function sizeScrollbar($scrollContent, $scrollPane) {
      var remainder = $scrollContent.width() - $scrollPane.width();
      var proportion = remainder / $scrollContent.width();
      var handleSize = $scrollPane.width() - proportion * $scrollPane.width();
      var handleHelper = $scrollPane.find(".ui-slider-handle");

      $scrollContent.find(".ui-slider-handle").css({
        width: handleSize,
        "margin-left": -handleSize / 2,
      });
      handleHelper.width("").width($scrollPane.width() - handleSize);
    },

    // Reset slider value based on scroll content position
    resetValue: function ($scrollContent, $scrollPane) {
      var remainder = $scrollPane.width() - $scrollContent.width();
      var leftVal =
        $scrollContent.css("margin-left") === "auto"
          ? 0
          : parseInt($scrollContent.css("margin-left"));
      var percentage = Math.round((leftVal / remainder) * 100);

      scrollbar.slider("value", percentage);
    },

    // If the slider is 100% and window gets larger, reveal content
    reflowContent: function ($scrollContent, $scrollPane) {
      var showing =
        $scrollContent.width() +
        parseInt($scrollContent.css("margin-left"), 10);
      var gap = $scrollPane.width() - showing;

      if (gap > 0) {
        $scrollContent.css(
          "margin-left",
          parseInt($scrollContent.css("margin-left"), 10) + gap
        );
      }
    },
  };
  var methods = {
    add: function (o) {
      methods.init.apply(this, arguments);

      return this.each(function () {
        var options = o;
        var defaults = {
          after: null,
          el: null,
          class: "",
        };
        var $this = $(this);
        var $div = $("<div></div>", {
          class: "picker-scroll-content-item",
        }).addClass(options["class"]);

        $div.append($(options.el).clone());
        $(".picker-scroll-content-item", $this).length;
        var data = $this.data("options");

        methods.resize.apply(this, [data.nb_items + 1]);

        return $div.insertAfter($(options.after, $this));
      });
    },

    resize: function (nb_items) {
      var $this = $(this);
      var data = $this.data("options");
      var $scrollContent = $(".picker-scroll-content", $this);

      if (!$scrollContent.length) {
        return;
      }

      var item_size =
        $(".picker-scroll-content-item:first", $this).outerWidth() +
        2 * 4 +
        2 * 3;

      if (!nb_items) {
        nb_items = data.nb_items;
      }

      $this.data("options", data);
      $scrollContent.css("width", item_size * Math.ceil(nb_items / data.rows));
    },

    progressive_content_behavior: function (options) {
      var $this = $(this);
      var $scrollPane = $(".picker-scroll-pane", $this);
      var $scrollContent = $(".picker-scroll-content", $this);

      $.get(options.url_feed, function (data) {
        var page_obj = data.paginator;

        options.nb_items = page_obj.object_count;
        options.page_range = page_obj.page_range;
        options.page_range[page_obj.page_number].loaded = true;
        $this.data("options", options);
        methods.resize.apply($this, []);
        log("page_obj = " + concatObject(data.paginator));

        for (d in data.designs) {
          var $d = options.content_builder(data.designs[d]);

          $scrollContent.append($d);
        }

        $scrollPane.css("overflow", "hidden");
      });
    },

    loaded_content_beahvior: function (options) {
      var $this = $(this);

      if (!options.nb_items) {
        options.nb_items = $(".picker-scroll-content-item", $this).length;
        $this.data("options", options);
      }

      var $scrollPane = $(".picker-scroll-pane", $this);

      if (!$scrollPane.length) {
        return;
      }

      var $scrollContent = $(".picker-scroll-content", $scrollPane);

      methods.resize.apply(this, []);

      // Build slider
      var scrollbar = $(".picker-scroll-bar", $this).slider({
        slide: function (event, ui) {
          if ($scrollContent.width() > $scrollPane.width()) {
            $scrollContent.css(
              "margin-left",
              Math.round(
                (ui.value / 100) *
                  ($scrollPane.width() - $scrollContent.width())
              ) + "px"
            );
          } else {
            $scrollContent.css("margin-left", 0);
          }
        },
      });

      // Append icon to handle
      var handleHelper = scrollbar
        .find(".ui-slider-handle")
        .mousedown(function () {
          scrollbar.width(handleHelper.width());
        })
        .mouseup(function () {
          scrollbar.width("100%");
        })
        .append("<span class='ui-icon ui-icon-grip-dotted-vertical'></span>")
        .wrap("<div class='ui-handle-helper-parent'></div>")
        .parent();

      // Change overflow to hidden now that slider handles the scrolling
      $scrollPane.css("overflow", "hidden");

      // Size scrollbar and handle proportionally to scroll distance
      if (options.resizeable) {
        // Change handle position on window resize
        $(window).resize(function () {
          internal.resetValue($scrollContent, $scrollPane);
          internal.sizeScrollbar($scrollContent, $scrollPane);
          internal.reflowContent($scrollContent, $scrollPane);
        });
      }

      // Init scrollbar size, Safari wants a timeout
      setTimeout(function () {
        internal.sizeScrollbar($scrollContent, $scrollPane);
      }, 10);

      $scrollContent.bind("mousewheel", function (event, delta) {
        var cur = $(".picker-scroll-bar", $this).slider("value");
        var new_value =
          cur -
          Math.round((delta * 100) / ((2 * options.nb_items) / options.rows));

        if (new_value < 0) {
          new_value = 0;
        } else if (new_value > 100) {
          new_value = 100;
        }

        $(".picker-scroll-bar", $this).slider("value", new_value);

        if ($scrollContent.width() > $scrollPane.width()) {
          $scrollContent.css(
            "margin-left",
            Math.round(
              (new_value / 100) * ($scrollPane.width() - $scrollContent.width())
            ) + "px"
          );
        } else {
          $scrollContent.css("margin-left", 0);
        }

        event.preventDefault();
      });
    },

    init: function (o) {
      return this.each(function () {
        var $this = $(this);
        var options = o;
        var data = $this.data("options");

        if (data) {
          return;
        }

        var defaults = {
          resizeable: false,
          rows: 2,
          nb_items: null,
          url_feed: "",
          content_builder: function () {
            log("build content: todo");
          },
        };
        var options = $.extend(defaults, o);

        $this.data("options", options);

        if (!options.url_feed) {
          methods.loaded_content_beahvior.apply($this, [options]);
        } else {
          methods.progressive_content_behavior.apply($this, [options]);
        }
      });
    },
  };

  $.fn.SculpteoHorizontalPicker = function (method) {
    if (methods[method]) {
      return methods[method].apply(
        this,
        Array.prototype.slice.call(arguments, 1)
      );
    } else if (typeof method === "object" || !method) {
      return methods.init.apply(this, arguments);
    } else {
      $.error(
        "Method " +
          method +
          " does not exist on jQuery.SculpteoHorizontalPicker"
      );
    }
  };
})(jQuery);

function color3f_to_html(r, g, b) {
  var c;

  c =
    "#" +
    (r * 255 < 16 ? "0" : "") +
    parseInt(r * 255).toString(16) +
    (g * 255 < 16 ? "0" : "") +
    parseInt(g * 255).toString(16) +
    (b * 255 < 16 ? "0" : "") +
    parseInt(b * 255).toString(16);

  return c;
}

// KeyCode helper object.
var KeyCode = {
  shift: 16,
  ctrl: 17,
  space: 32,
};

// MouseButton helper object.
var MouseButton = {
  left: 1,
  middle: 2,
  right: 3,
};
